/* ==========================================================================
   lp-progress.js — mobilde ust kisimda "sayfanin kacta kaci okundu"
   gosteren ince ilerleme cubugu.
   ==========================================================================

   lp-reveal.js'e DOKUNULMADI, kasitli olarak AYRI dosya.

   DIKKAT: Horizon temasinda masaustunde (>=990px) sayfa <body>/document
   degil ".page-wrapper" kutusu icinde kaydirilabiliyor; bu davranis
   mobilde de gorulebiliyor. Bu yuzden hangi elemanin GERCEKTEN kaydigi
   calisma zamaninda tespit edilir:
     - ".page-wrapper" varsa VE scrollHeight > clientHeight ise o dinlenir,
     - yoksa document.scrollingElement (klasik dokuman kaydirmasi) dinlenir.

   Performans: her "scroll" olayinda hesap yapilmaz; requestAnimationFrame
   ile bir sonraki frame'e kadar tek hesap biriktirilir (throttle).

   Gorsel cubuk CSS ile mobilde (<768px) gosteriliyor, masaustunde
   gizleniyor (assets/lp.css: .lp-progress-bar). Bu script hareket
   azaltma tercihinden (prefers-reduced-motion) etkilenmez; cubuk bir
   animasyon degil, bir gosterge (ilerleme durumu) oldugu icin.
   ========================================================================== */

(function () {
  'use strict';

  function getScrollTarget() {
    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper && wrapper.scrollHeight > wrapper.clientHeight) {
      return {
        el: wrapper,
        getScrollTop: function () {
          return wrapper.scrollTop;
        },
        getScrollHeight: function () {
          return wrapper.scrollHeight;
        },
        getClientHeight: function () {
          return wrapper.clientHeight;
        }
      };
    }

    var scrollingElement =
      document.scrollingElement || document.documentElement;

    return {
      el: window,
      getScrollTop: function () {
        return scrollingElement.scrollTop || window.pageYOffset || 0;
      },
      getScrollHeight: function () {
        return scrollingElement.scrollHeight;
      },
      getClientHeight: function () {
        return scrollingElement.clientHeight || window.innerHeight;
      }
    };
  }

  function start() {
    var fill = document.querySelector('[data-lp-progress-fill]');
    if (!fill) return;

    var target = getScrollTarget();
    var ticking = false;

    function update() {
      ticking = false;

      var scrollTop = target.getScrollTop();
      var scrollHeight = target.getScrollHeight();
      var clientHeight = target.getClientHeight();
      var maxScroll = scrollHeight - clientHeight;

      var ratio = maxScroll > 0 ? scrollTop / maxScroll : 0;
      if (ratio < 0) ratio = 0;
      if (ratio > 1) ratio = 1;

      fill.style.width = ratio * 100 + '%';
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    target.el.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
